var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{class:'circle_z1 ' + (_vm.isOnline ? 'icon_green' : 'icon_gray')}),_c('div',{class:['circle', _vm.iconColorCss]},[_c('span',[_vm._v(" "+_vm._s(_vm.occupationShortName)+" "),_c('br'),_vm._v(_vm._s(_vm.name)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }